import axiosInstance from "../utils/axios-instance";

export const countryService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post("/country", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (limit, skip, text, type) => {
    try {
      let response = await axiosInstance.get(
        `/country?&$limit=${limit || 15}&$skip=${skip || 0}&${
          text?.trim() ? `${type}[$search]=${text.trim()}` : ""
        }`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  get: async (id) => {
    try {
      let response = await axiosInstance.get(`/country/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (data, id) => {
    try {
      let response = await axiosInstance.patch(`/country/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/country/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
